var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916626 19.2499L11 1.83325L21.0833 19.2499H0.916626ZM3.29996 17.8749H18.7L11 4.58325L3.29996 17.8749ZM11.0916 16.5687C11.2902 16.5687 11.4545 16.5037 11.5843 16.3739C11.7142 16.244 11.7791 16.0798 11.7791 15.8812C11.7791 15.6826 11.7142 15.5183 11.5843 15.3885C11.4545 15.2586 11.2902 15.1937 11.0916 15.1937C10.893 15.1937 10.7288 15.2586 10.5989 15.3885C10.4691 15.5183 10.4041 15.6826 10.4041 15.8812C10.4041 16.0798 10.4691 16.244 10.5989 16.3739C10.7288 16.5037 10.893 16.5687 11.0916 16.5687ZM10.4041 14.0249H11.7791V8.89158H10.4041V14.0249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a99bfc2523c0873ec8b796fbea714a24.svg";
export { ForwardRef as ReactComponent };